import { LoadingButton } from "@mui/lab";
import { Box, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { useState } from "react";
import { FieldValues, useForm } from "react-hook-form";
import { PeopleService } from "../../../Component/Api/People/peopleService";
import AppTextInput from "../../../Component/Common/Components/FormValidationInputs/AppTextInput";
import { SkeletonLoading } from "../../../Component/Common/SkeletonLoading/SkeletonLoading";
import { yupResolver } from "@hookform/resolvers/yup";
import { addPersonSchema } from "./CheckPersonValidation";
import { PeopleDtos } from '../../../Component/Model/Dto/People';
import { CustomDialogTitle } from "../../Common/Custom/CustomDialogTitle";
import { toast } from "react-toastify";
import React from "react";
import { ScorecardLink } from "../../../Component/Model/Dto/PeopleScorecardLink";

interface IProps {
  showPersonCheckModal: boolean;
  closePersonCheckModal: () => void;
  setPerson: (person: PeopleDtos.GetPersonRequest | null) => void;
  scorecardId: string;
  handleEdit: (id: number) => void;
  setIdAndEmployeeCode: (id: string, employeeCode: string) => void;
}

export const CheckPersonModal = (props: IProps) => {
  const { control, handleSubmit, formState: { isSubmitting }, getValues} = useForm({
    mode: 'all',
    resolver: yupResolver(addPersonSchema)
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [peopleScorecardSearchRequest, setPeopleScorecardSearchRequest] = useState<ScorecardLink.SearchRequest>({
    pageNumber: 1,
    pageSize: 20,
    searchValue: "",
    personId: 0
  });

  const handleDataSubmit = async (data: FieldValues) => {
    const checkPersonRequest: PeopleDtos.CheckPerson = {
      identificationNumber: data.identificationNumber === "" ? null : data.identificationNumber,
      employeeCode: data.employeeCode === "" ? null : data.employeeCode
    }
    setIsLoading(true)
    try {
      const result = await PeopleService.GetPersonBeforeCreate(checkPersonRequest);
      if (result.data !== null) {
        peopleScorecardSearchRequest.personId = result.data.id;
        const scorecardLinks = await PeopleService.GetScorecardLinks(peopleScorecardSearchRequest);
        if(scorecardLinks.data.totalItemsCount > 0){
          const personScorecardLinks = scorecardLinks.data.results.filter(sl => sl.scorecardId === props.scorecardId);
          if(personScorecardLinks.length > 0 ){
            toast.warning(`An individual with the ID Number ${result.data.identificationNumber} and Employee Code ${result.data.employeeCode} has already been added to the scorecard`);
          }
          else {
            props.setPerson(result.data);
          }
        }
        else{
          props.setPerson(result.data);
        }
      }
      else {
        props.setIdAndEmployeeCode(getValues("identificationNumber"), getValues("employeeCode"));
        props.setPerson(null);
      }
    } catch (error) {
      props.setIdAndEmployeeCode(getValues("identificationNumber"), getValues("employeeCode"));
      props.setPerson(null);
    } finally {
      setIsLoading(false)
    }

  }


  if (isLoading) {
    return (
      <SkeletonLoading formLoading FieldAmount={6} />
    )
  }
  return (
    <Dialog disableEnforceFocus open={props.showPersonCheckModal} onClose={() => { props.closePersonCheckModal() }} aria-labelledby="form-dialog-title" maxWidth='lg'>
      <CustomDialogTitle id="personcheck-dialog-title" onClose={() => props.closePersonCheckModal()}>
        Capture New Employee
      </CustomDialogTitle>
      <DialogContent>
        <Box>
          <form id='checkPersonForm' onSubmit={handleSubmit(handleDataSubmit)}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} mt={2}>
                <AppTextInput control={control} name="identificationNumber" label="ID Number" />
              </Grid>
              <Grid item xs={12} sm={12}>
                <AppTextInput control={control} name="employeeCode" label="Employee Code" />
              </Grid>
            </Grid>
          </form>
        </Box >
      </DialogContent>
      <DialogActions>
        <Box>
          <LoadingButton loading={isSubmitting} variant='contained' form='checkPersonForm' type="submit" color='primary'>
            Retrieve
          </LoadingButton>
        </Box>
      </DialogActions>
    </Dialog>
  )
}